"use strict";
/**
 * 期权上交所 深交所
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageOptionQiHuo = void 0;
var react_1 = __importStar(require("react"));
var crumbs_1 = require("../crumbs");
var react_router_dom_1 = require("react-router-dom");
var qiquantab_1 = require("./shared/qiquantab");
var qihuotable_1 = require("../qihuotable");
var delaytips_1 = require("./shared/delaytips");
var hk_rule_1 = __importDefault(require("../../modules/hk_rule"));
/**
 * 需要展示延时tip
 */
var showdelayhash = [
    '#options_cffex_all',
    '#options_zjcffex_all',
    '#options_zjcffex_rengou',
    '#options_zjcffex_rengu',
    '#options_zjcffex_mo_all',
    '#options_zjcffex_mo_rengou',
    '#options_zjcffex_mo_rengu',
    '#options_zjcffex_ho_all',
    '#options_zjcffex_ho_rengou',
    '#options_zjcffex_ho_rengu',
];
/**
 * 期货期权
 */
function PageOptionQiHuo() {
    var _this = this;
    var location = (0, react_router_dom_1.useLocation)();
    var hash = location.hash;
    var _a = (0, react_1.useState)(false), mounted = _a[0], setMounted = _a[1];
    var _b = (0, react_1.useState)({ re: false, message: "" }), delaymessage = _b[0], setDelayMess = _b[1];
    (0, react_1.useEffect)(function () {
        ;
        (function () { return __awaiter(_this, void 0, void 0, function () {
            var delay_hk;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, hk_rule_1.default.isDelayCache()];
                    case 1:
                        delay_hk = _a.sent();
                        if (delay_hk === null || delay_hk === void 0 ? void 0 : delay_hk.re) {
                            setDelayMess(delay_hk);
                        }
                        // setDelayMess({   // 测试字段
                        //   re: true,
                        //   message: "非中国大陆用户仅可查看港股延时15分钟行情"
                        // })
                        setMounted(true);
                        return [2 /*return*/];
                }
            });
        }); })();
    }, []);
    if (!mounted)
        return react_1.default.createElement(react_1.default.Fragment, null);
    return (react_1.default.createElement("div", { className: "pageopt" },
        showdelayhash.indexOf(hash) > -1 && react_1.default.createElement(crumbs_1.CrumbsNoRefresh, { insertRight: (0, delaytips_1.DelayMin15Tip)() }),
        showdelayhash.indexOf(hash) < 0 && react_1.default.createElement(crumbs_1.CrumbsWithRefreshLine, null),
        react_1.default.createElement(qiquantab_1.CustomQiQuanMainTab2, null),
        hash == '#options_uscny_all' ? react_1.default.createElement(qihuotable_1.QiHuoTable, null)
            :
                react_1.default.createElement(qihuotable_1.QiHuoTable, null)));
}
exports.PageOptionQiHuo = PageOptionQiHuo;
